import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import PerfectScrollBar from 'react-perfect-scrollbar';
import { Col } from 'react-bootstrap';
import {
  makeGetToken,
  makeGetListAccount,
  makeGetDefaultAccount,
  makeGetHisTransfer,
  makeGetCashBalance,
  makeGetCashOut,
  makeGetBankList,
} from '../../lib/selector';

import {
  hisTransferRequest,
  bankListRequest,
} from '../../containers/cash/actions';

import {
  setCashOut,
  setToast,
  unsetClient,
} from '../../containers/client/actions';
import {
  numberFormat,
  formatDate,
  getTransferStatus,
  removeAccent,
  getMessageError,
  replaceAll,
} from '../../utils';

// import { Link } from 'react-router-dom';
import FormHisNapRutTien from './form/formHisNapRutTien';
import { v4 as uuidv4 } from 'uuid';
import PaginationTable from '../PaginationTable';
import { Logout, logoutRequest } from '../modal/login/actions';
import { translate } from 'react-i18next';
import { isEqual } from 'lodash';

class NapRutTien extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      transType: '1',
    };
  }

  componentDidMount() {
    this._handleLoadListBank();
    this._handleLoadListTransfer();
  }

  componentDidUpdate(preProps) {
    const { defaultAccount, cashOut, token, t } = this.props;
    if (defaultAccount && !isEqual(defaultAccount, preProps.defaultAccount)) {
      this._handleLoadListTransfer(this.state.transType);
    }

    if (cashOut && cashOut !== preProps.cashOut) {
      console.log(cashOut);
      if (cashOut.http !== 200) {
        if (cashOut.http === 401) {
          if (token) this.props.dispatch(logoutRequest(token));

          this.props.dispatch(unsetClient());
          localStorage.removeItem('token');
          sessionStorage.removeItem('authen');

          this.props.dispatch(Logout());
          this._handleToast(t('txt-valid-loss-session'));
        } else {
          this._handleToast(
            getMessageError(cashOut, this.props.store.getState)
          );
        }
      } else {
        // success
        this._handleToast(t('txt-title-transfer-success'));
        this._handleLoadListTransfer(this.state.transType);
        this.props.dispatch(setCashOut(false));
      }
    }
  }

  _handleToast = (msg) => {
    const toastMsg = {
      id: Math.random(),
      msg: msg,
      title: this.props.t('txt-notice'),
    };
    this.props.dispatch(setToast(toastMsg));
  };

  _handleLoadListTransfer = (type = '1') => {
    const { token, defaultAccount } = this.props;
    if (!defaultAccount || !token) return;
    this.setState({ transType: type });
    const numDay = token && token['config'] ? token['config']['numDay'] : 30;

    const d = new Date();
    d.setDate(d.getDate() - numDay);

    const uuid = uuidv4();
    const resData = {
      group: 'CORE',
      user: token.user,
      session: token.session,
      cmd: 'getCashTransferHist',
      rqId: uuid,
      channel: 'WTS',
      data: {
        acntNo: defaultAccount.acntNo,
        subAcntNo: defaultAccount.subAcntNo,
        fromDate: formatDate(d, ''),
        toDate: formatDate(new Date(), ''),
        transType: type,
      },
    };

    this.props.dispatch(hisTransferRequest(resData));
  };

  _handleLoadListBank = () => {
    const { token } = this.props;

    const uuid = uuidv4();
    const resData = {
      group: 'BACK',
      user: token.user,
      session: token.session,
      cmd: 'BANK_LIST',
      rqId: uuid,
      channel: 'WTS',
    };

    this.props.dispatch(bankListRequest(resData));
  };

  _handleCopyToClipboard = (e) => {
    var textToCopy = e.innerText;
    // console.log(e, e.attributes.name)
    if (!e.attributes.name) textToCopy = replaceAll(textToCopy, ' ', '');

    var tempInputElement = document.createElement('input');
    tempInputElement.type = 'text';
    tempInputElement.value = textToCopy;

    document.body.appendChild(tempInputElement);

    tempInputElement.select();
    document.execCommand('Copy');

    document.body.removeChild(tempInputElement);
    this._handleToast('Copied to clipboard');
  };

  render() {
    const {
      token,
      cashBalance,
      hisTransfer,
      defaultAccount,
      bankList,
      t,
      lang,
    } = this.props;
    console.log('hisTransfer', hisTransfer);
    const columns = [
      {
        key: 'defaultAccount',
        text: t('txt-label-source'),
        className: 'text-center',
        align: 'center',
        cell: (record) => {
          return <span>{record && record.subAcntNo}</span>;
        },
      },
      {
        key: 'toAcntNo',
        text: t('txt-label-target'),
        className: 'text-right',
        align: 'center',
      },
      // {
      //   text: 'Số dư nguồn',
      //   className: 'text-right',
      //   align: 'right',
      // },
      {
        key: 'trdAmt',
        text: t('txt-label-amount-want-transfer'),
        className: 'text-right',
        align: 'center',
        cell: (record) => {
          return numberFormat(record.trdAmt, 0, '0');
        },
      },
      {
        key: 'desc',
        text: t('txt-label-cash-transfer-content'),
        className: 'text-left',
        align: 'center',
      },
      {
        key: 'status',
        text: t('txt-status'),
        className: (record) => {
          return (
            'text-left ' +
            (record.status === '1' ? 'r' : record.status === '2' ? 'i' : 'd')
          );
        },
        align: 'center',
        cell: (record) => {
          return getTransferStatus(record.status);
        },
      },
      {
        key: 'trdDt',
        text: t('txt-label-create-date'),
        className: 'text-right',
        align: 'center',
      },
    ];
    return (
      <Fragment>
        <div
          className="d-flex flex-row align-items-center"
          style={{ height: '56px', borderBottom: '1px solid rgb(83, 90, 134)' }}
        >
          <Col
            xs
            lg="2"
            className="d-flex flex-column"
            style={{ borderRight: '1px solid #42465b' }}
          >
            <span className="txt-content fz-14">
              {t('txt-asset-cash-balance')}
            </span>
            <span className="i fz-14">
              {cashBalance && numberFormat(cashBalance.cashBalance, 0, '0')}
            </span>
          </Col>
          <Col className="d-flex flex-column">
            <span className="txt-content fz-14">{t('txt-wdrawAvail')}</span>
            <span className="i fz-14">
              {cashBalance && numberFormat(cashBalance.wdrawAvail, 0, '0')}
            </span>
          </Col>
          <Col md="auto" className="p-3">
            <a
              onClick={() => this.props.dispatch(setCashOut(true))}
              className="btn btn-info fz-14 font-weight-bold text-white"
            >
              {t('txt-label-withdrawal')}
            </a>
          </Col>
        </div>
        <PerfectScrollBar>
          <p className="text-white fz-18 pl-3 mt-3">
            {t('txt-label-deposit-stock')}
          </p>
          <div className="d-flex flex-row">
            <Col className="d-flex flex-column pr-0">
              <table className="table table-bordered">
                <tbody>
                  <tr style={{ borderTop: '1px solid #42465b' }}>
                    <td>{t('txt-label-beneficiary')}</td>
                    <td className="d-flex border-0 align-items-center">
                      <span
                        ref={(benefit) => (this.textBenefit = benefit)}
                        className="mr-auto text-white font-weight-bold fz-14"
                      >
                        {bankList ? bankList.ctck : ''}
                      </span>
                      {/* <button
                        onClick={() =>
                          this._handleCopyToClipboard(this.textBenefit)
                        }
                        className="btn-reload text-white"
                      >
                        Copy
                      </button> */}
                    </td>
                  </tr>
                  {bankList &&
                    bankList.list &&
                    !!bankList.list.length &&
                    bankList.list.map((item, index) => (
                      <tr
                        style={{ borderTop: '1px solid #42465b' }}
                        key={index}
                      >
                        {index === 0 && (
                          <td
                            rowSpan={bankList.list.length}
                            className="align-top"
                          >
                            {`${t('txt-label-account-beneficiary')} (${t(
                              'txt-label-choose'
                            )} 1)`}
                          </td>
                        )}
                        <td className="d-flex border-0 align-items-center" style={{minHeight: '50px'}}>
                          <div className="mr-auto d-flex flex-column">
                            <span className="fz-14">
                              {item.bankName} &nbsp;
                            </span>
                            <span
                              className="fz-14 text-white font-weight-bold"
                              ref={(el) =>
                                (this[
                                  item.bankCode + '_' + index + '_ref'
                                ] = el)
                              }
                            >
                              {item.bankAcc}
                            </span>
                          </div>
                          <button
                            onClick={() =>
                              this._handleCopyToClipboard(
                                this[item.bankCode + '_' + index + '_ref']
                              )
                            }
                            className="btn-reload text-white"
                          >
                            Copy
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </Col>
            <Col className="d-flex flex-column">
              <p className="text-white fz-14 mt-1">
                {t('txt-label-transfer-content')}
              </p>
              <div
                className="d-flex align-items-center bg-white p-3"
                style={{ borderRadius: '5px' }}
              >
                <span
                  ref={(contentText) => (this.contentText = contentText)}
                  className="mr-auto fz-18 font-weight-bold"
                  name="contentText"
                >
                  {token &&
                    defaultAccount &&
                    `${defaultAccount.vsdAcntNo} ${removeAccent(
                      token.name
                    )} ${t('txt-transfer-content')}`}
                </span>
                <button
                  onClick={() => this._handleCopyToClipboard(this.contentText)}
                  className="btn-reload text-white"
                >
                  Copy
                </button>
              </div>
              <div
                className="fz-14 p-3 mt-2"
                style={{
                  borderRadius: '5px',
                  backgroundColor: '#e6fffe',
                  color: '#1BA0E1',
                }}
              >
                {t('txt-gd')}
              </div>
            </Col>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-4">
            <label className="text-white text-uppercase ml-2 fz-14">
              {t('txt-label-history')}
            </label>
            <FormHisNapRutTien handleQuery={this._handleLoadListTransfer} />
          </div>
          <PaginationTable
            defaultAccount={defaultAccount}
            pageSize={15}
            columns={columns}
            source={hisTransfer && hisTransfer.list ? hisTransfer.list : []}
          />
        </PerfectScrollBar>
      </Fragment>
    );
  }
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getListAccount = makeGetListAccount();
  const getDefaultAccount = makeGetDefaultAccount();
  const getCashBalance = makeGetCashBalance();
  const getCashOut = makeGetCashOut();

  const getListTransfer = makeGetHisTransfer();
  const getBankList = makeGetBankList();

  const mapStateToProps = (state) => {
    console.log(state);
    return {
      token: getToken(state),
      listAccount: getListAccount(state),
      defaultAccount: getDefaultAccount(state),
      cashBalance: getCashBalance(state),
      hisTransfer: getListTransfer(state),
      cashOut: getCashOut(state),
      bankList: getBankList(state),
      lang: state.client.setting.lang || 'vi',
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(
  translate('translations')(NapRutTien)
);
